<template>
  <div class="subpage main_area">
    <div class="type_menu_area">
      <div class="type_menu menu_area_bg">
        <div :class="showType == 1 ? ' type_menu_item active' : 'type_menu_item'" @click="changPayType('showType', 1)">
          <a><span>交易记录</span></a>
        </div>
        <div :class="showType == 2 ? ' type_menu_item active' : 'type_menu_item'" @click="changPayType('showType', 2)">
          <a><span>返水记录</span></a>
        </div>
        <div :class="showType == 3 ? ' type_menu_item active' : 'type_menu_item'" @click="changPayType('showType', 3)">
          <a><span>投注记录</span></a>
        </div>
      </div>
    </div>
    <div class="type_menu_area" style="padding-bottom: 4px">
      <select class="filter_search" v-model="api_type" name="filter_search" @change="satusSelect">
        <option :value="''">全平台</option>
        <option v-for="(item, index) in dogameLis" :key="index" :value="item.platname">{{ item.name }}</option>
      </select>
    </div>
    <!-- 交易记录   -->
    <div v-if="showType == 1">
      <div class="sub_list_tab wallet_history_tab">
        <a :class="type == 1 ? 'block_content active' : 'block_content'" @click="changPayType('type', 1)">存款</a>
        <a :class="type == 2 ? 'block_content active' : 'block_content'" @click="changPayType('type', 2)">取款</a>
        <a :class="type == 3 ? 'block_content active' : 'block_content'" @click="changPayType('type', 3)">转入</a>
        <a :class="type == 4 ? 'block_content active' : 'block_content'" @click="changPayType('type', 4)">转出</a>

        <div class="block_content history_day_filter">
          <label class="icon-day">
            <select class="filter_search" v-model="date" name="filter_search" @change="satusSelect">
              <option :value="1">今日</option>
              <option :value="2">一周内</option>
              <option :value="3">半月内</option>
              <option :value="4">一月内</option>
            </select>
            <div class="error_msg"></div>
          </label>
        </div>
      </div>
      <div class="">
        <div class="detail_area">
          <div class="layout intl_wallet_layout record_wallet_details">
            <div class="mypromo_filter_block">
              <input type="hidden" id="date_check" />
            </div>
            <div id="data_display">
              <div class="">
                <!-- <div class="table_header_title active"><span class="expendable">11月份</span></div> -->
                <ul v-if="transrecordList.length > 0" class="table_listing 11">
                  <li v-for="(item, index) in transrecordList" :key="index">
                    <div class="block_content data_content">
                      <div class="date_time_id">
                        <div class="block_content datetime_content">
                          <!-- <div class="date">15</div> -->
                          <div class="time">{{ item.created_at }}</div>
                        </div>
                        <div class="trans_id">
                          <div v-if="type == 1 || type == 2">{{ item.out_trade_no }}</div>
                          <!-- <img alt="" src="/static/image/copy.png" class="svg copy_btn" data-clipboard-text="3945306"> -->
                        </div>
                      </div>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <span class="trans_type">{{ item.pay_way }} </span> 金额<span class="trans_type">{{ item.amount }} </span>
                            </td>
                            <td class="data" v-if="type == 1 || type == 2" style="text-align: right">
                              <div class="status_tag process">{{ stateType12[item.state] }}</div>
                            </td>
                            <td class="data" v-if="type == 3 || type == 4" style="text-align: right">
                              <div class="status_tag process">{{ stateType34[item.state] }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </ul>
                <div class="no_data" v-if="transrecordList.length == 0">
                  <img alt="" src="/static/image/img_emptybox.png" width="30%" />
                  <div>暂无资料</div>
                </div>
                <div v-if="transrecordList.length > 0 && transrecordListShowData.last_page > 1" style="width: 80%; margin: 0 auto">
                  <van-pagination v-model="page" :page-count="transrecordListShowData.last_page" @change="getTransrecord" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 返水记录   -->
    <div v-if="showType == 2">
      <div class="sub_list_tab wallet_history_tab">
        <a :class="date == 1 ? 'block_content active' : 'block_content'" @click="changPayType('date', 1)">今日</a>
        <a :class="date == 2 ? 'block_content active' : 'block_content'" @click="changPayType('date', 2)">一周内</a>
        <a :class="date == 3 ? 'block_content active' : 'block_content'" @click="changPayType('date', 3)">半月内</a>
        <a :class="date == 4 ? 'block_content active' : 'block_content'" @click="changPayType('date', 4)">一月内</a>
      </div>
      <div class="">
        <div class="detail_area">
          <div class="layout intl_wallet_layout record_wallet_details">
            <div class="mypromo_filter_block">
              <input type="hidden" id="date_check" />
            </div>
            <div data-v-5c998777="" class="deposit_header tableheader_bg" style="background: #fff !important">
              <div data-v-5c998777="" style="color: #000 !important">累计领取 {{ jisuan }}</div>
              <div data-v-5c998777="" class="d-flex align-items-center" style="color: #000 !important">
                <span data-v-5c998777="" id="wallet_bal" class="wallet_balance mr-2 main_wallet_bal" style="font-size: 14px; font-weight: 400; color: #000 !important">待领取{{ nojisuan }}</span>
                <!-- <img   data-v-5c998777="" alt="" src="/static/image/refresh_reverse.png" id="reload_wallet" /> -->
                <span @click="lingqu" style="font-size: 10px; border: 1px solid #ccc; border-radius: 4px; padding: 1px 4px; color: #333" id="reload_wallet">点击领取</span>
              </div>
            </div>
            <div id="data_display">
              <div class="">
                <!-- <div class="table_header_title active"><span class="expendable">11月份</span></div> -->
                <ul v-if="fanshuiList.length > 0" class="table_listing 11">
                  <li v-for="(item, index) in fanshuiList" :key="index">
                    <div class="block_content data_content">
                      <div class="date_time_id">
                        <div class="block_content datetime_content">
                          <div class="time">{{ item.created_at }}</div>
                          <!-- <div class="date"></div> -->
                        </div>
                        <div class="trans_id">
                          <div>{{ item.gamename }}</div>
                          <!-- <img alt="" src="/static/image/copy.png" class="svg copy_btn" data-clipboard-text="3945306"> -->
                        </div>
                      </div>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <span class="trans_type">{{ item.state == 0 ? '待领取' : '已领取' }} </span> 金额<span class="trans_type">{{ item.money }} </span>
                            </td>
                            <td class="data" style="text-align: right">
                              <div>{{ item.state == 0 ? '暂未领取' : item.updated_at }}</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </ul>
                <div class="no_data" v-if="fanshuiList.length == 0">
                  <img alt="" src="/static/image/img_emptybox.png" width="30%" />
                  <div>暂无资料</div>
                </div>
                <div v-if="fanshuiList.length > 0 && fanshuishowData.last_page > 1" style="width: 80%; margin: 0 auto">
                  <van-pagination v-model="page" :page-count="fanshuishowData.last_page" @change="getfanshui" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 投注记录   -->
    <div v-if="showType == 3">
      <div class="sub_list_tab wallet_history_tab">
        <a :class="date == 1 ? 'block_content active' : 'block_content'" @click="changPayType('date', 1)">今日</a>
        <a :class="date == 2 ? 'block_content active' : 'block_content'" @click="changPayType('date', 2)">一周内</a>
        <a :class="date == 3 ? 'block_content active' : 'block_content'" @click="changPayType('date', 3)">半月内</a>
        <a :class="date == 4 ? 'block_content active' : 'block_content'" @click="changPayType('date', 4)">一月内</a>
      </div>
      <div class="">
        <div class="detail_area">
          <div class="layout intl_wallet_layout record_wallet_details">
            <div class="mypromo_filter_block">
              <input type="hidden" id="date_check" />
            </div>
            <div id="data_display">
              <div class="">
                <!-- <div class="table_header_title active"><span class="expendable">11月份</span></div> -->
                <ul v-if="betrecordList.length > 0" class="table_listing 11">
                  <li v-for="(item, index) in betrecordList" :key="index">
                    <div class="block_content data_content">
                      <div class="date_time_id">
                        <div class="block_content datetime_content">
                          <!-- <div class="date">15</div> -->
                          <div class="time">{{ item.bet_time }}</div>
                        </div>
                        <div class="trans_id">
                          <div>{{ item.bet_id }}</div>
                          <!-- <img alt="" src="/static/image/copy.png" class="svg copy_btn" data-clipboard-text="3945306"> -->
                        </div>
                      </div>
                      <table>
                        <tbody>
                          <tr>
                            <td colspan="3">
                              <span class="trans_type">{{ item.Code }} </span>
                            </td>
                          </tr>
                             <tr>
                            <td >
                              <span class="trans_type">玩法：{{ item.playname }} </span>
                            </td>
                            <td colspan="2">
                              <span class="trans_type">内容：{{ item.playmemo }} </span>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="2">
                              派金<span class="trans_type">{{ item.bet_amount }} </span> 金额<span class="trans_type">{{ item.win_loss }} </span>
                            </td>
                            <td class="data" style="text-align: right">
                              <div class="status_tag process">{{ statuType[item.status] }}</div>
                            </td>
                          </tr>

                          <tr style="dis" @click="doCopy(item.gameno)">
                            <td colspan="2">期号局号：{{ item.gameno }}</td>
                            <td><span style="color: green">复制</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </ul>
                <div class="no_data" v-if="betrecordList.length == 0">
                  <img alt="" src="/static/image/img_emptybox.png" width="30%" />
                  <div>暂无资料</div>
                </div>
                <div v-if="betrecordList.length > 0 && betrecordShowData.last_page > 1" style="width: 80%; margin: 0 auto">
                  <van-pagination v-model="page" :page-count="betrecordShowData.last_page" @change="getbetrecord" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'meyList',
  data() {
    return {
      date: 1,
      page: 1,
      type: 1,
      api_type: '',
      showType: 1,
      stateType12: ['未定义', '待审核', '审核通过', '审核拒绝'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
      transrecordList: [],
      transrecordListShowData: {},
      fanshuiList: [],
      fanshuishowData: {},
      betrecordList: [],
      betrecordShowData: {},
      activityApplyLogList: [],
      activityApplyLogShowData: {},
      jisuan: null,
      nojisuan: null,
      statuType: ['无效注单', '已结算', '未结算'],
      statuTypeS: ['0未约定', '待审核', '通过', '拒绝', '4未约定'],
      dogameLis: [],
    };
  },
  created() {
    let that = this;
    that.getdogame();

    that.getData();
  },
  methods: {
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
        }
      });
    },
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, '暂无领取额度！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          console.log(res);
          that.$parent.getUserInfo();
          that.$parent.showTost(1, res.message);
          that.getfanshui();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    satusSelect(event) {
      // event.target.value 是change事件默认传的信息
      console.log(event.target.value);
      let that = this;
      that.page = 1;
      that.getData();
    },
    getData() {
      let that = this;
      that.getTransrecord();
      that.getfanshui();
      that.getbetrecord();
    },
    changPayType(name, val) {
      let that = this;
      if (that[name] == val) {
        return;
      }

      that[name] = val;
      if (name == 'showType') {
        //修改记录列表

        that.page = 1;
      }
      that.getData();
    },
    // 获取交易记录
    getTransrecord() {
      let that = this;
      that.$parent.showLoading();

      let info = {
        date: that.date,
        type: that.type,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.transrecordList = res.data.data;
            that.transrecordListShowData = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    // 获取返水记录
    getfanshui() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        api_type: that.api_type,
        type: '',
        page: that.page,
      };
      console.log(info);
      // return;betRecord
      that.$apiFun
        .post('/api/getfanshui', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.fanshuiList = res.data.list.data;
            that.fanshuishowData = res.data.list;
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    // 获取投注记录
    getbetrecord() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        date: that.date,
        page: that.page,
        api_type: that.api_type,
      };
      console.log(info);
      // return;betRecord
      that.$apiFun.post('/api/betrecord', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.betrecordList = res.data.data;
          that.betrecordShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.$parent.showTost(1, '复制成功！');
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.table_listing > li:before {
  content: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/meyList.vue